import React from 'react';
import { SearchEmptyIcon } from 'app/components/icons';
import './NoActiveSubscriptions.less';

export default function NoActiveSubscriptions() {
  return (
    <div className="no-active-subscriptions">
      <SearchEmptyIcon />
      <span className="no-active-subscriptions__text">
        No active subscriptions
      </span>
    </div>
  );
}
